import law from "./images/law.png";
import grp from "./images/grp.png";
import rupee from "./images/rupee.png";

export const c2cBenifits = [
    "6L+ Verified buyers",
    "Competitive pricing",
    "Control and transparency"
];

export const JOURNEY_STATUS = {
    PITCHED: "PITCHED",
    DELISTED: "DELISTED",
    REJECTED: "QC_REJECTED",
    SOLD: "SOLD",
    SOLD_WITHOUT_SPP: "SOLD_WITHOUT_SPP"
};

export const c2cBenifitsV2 =  [
    {
        label: "Set your own price",
        icon: rupee
    },
    {
        label: "Negotiate directly",
        icon: law
    },
    {
        label: "Get multiple offers",
        icon: grp
    }
];

export const marketPlaceBaseUrl = "/marketplace/";
